var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_111802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4109 11.6863C12.4109 11.3548 12.6793 11.0864 13.0108 11.0864L18.0677 11.0864L16.6919 9.71053C16.4577 9.47631 16.4577 9.09623 16.6919 8.862C16.9261 8.62778 17.3062 8.62778 17.5404 8.862L19.9404 11.262C20.1747 11.4963 20.1747 11.8763 19.9404 12.1106L17.5404 14.5106C17.3062 14.7448 16.9261 14.7448 16.6919 14.5106C16.4577 14.2763 16.4577 13.8963 16.6919 13.662L18.0677 12.2862L13.0108 12.2862C12.6793 12.2862 12.4109 12.0177 12.4109 11.6863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.687 12.1106L5.08702 14.5106C5.32125 14.7448 5.70132 14.7448 5.93555 14.5106C6.16978 14.2764 6.16978 13.8963 5.93555 13.6621L4.55973 12.2862L9.61665 12.2862C9.78237 12.2862 9.93237 12.2191 10.0409 12.1106C10.1495 12.002 10.2166 11.852 10.2166 11.6863C10.2166 11.3548 9.9481 11.0864 9.61665 11.0864L4.55972 11.0864L5.93554 9.71055C6.16977 9.47632 6.16977 9.09625 5.93554 8.86202C5.70132 8.62779 5.32124 8.62779 5.08702 8.86202L2.68699 11.262C2.45277 11.4963 2.45277 11.8763 2.687 12.1106Z",
    fill: "#0265DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_111802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 11.3137 0.372589)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.c074a19c44805266bf654eb9cdd09222.svg";
export { ForwardRef as ReactComponent };